import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { FormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, UserService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OwnerProfileService } from '../owner-profile.service';
import { OwnerProfile } from '../owner-profile';
import { PropertyService } from '@app/_components/property';
import { ConstantService } from '@app/_services/constant.service';
import { PropertyProfileService } from '@app/_components/property-profile/property-profile.service';
import { PropertyProfileComponent } from '@app/_components/property-profile/property-profile/property-profile.component';
import { UserTitles } from '@app/_helpers/constants';
import { PropertyProfile } from '@app/_components/property-profile/property-profile';
import {MsgTemplateData} from '@app/_components/msg-template/msg-template-data';
import { ActivatedRoute } from '@angular/router';
import { NotesChatConfig } from '@app/_components/_shared/notes-chat/notes-chat.component';

@Component({
    selector: 'app-owner-profile',
    templateUrl: './owner-profile.component.html',
    styleUrls: ['./owner-profile.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OwnerProfileComponent implements OnInit {
    properties: any;
    listingStatus: any[];
    countries: any;
    relationships: any[];
    contactPrefs: any[];
  isDataLoaded = false;
    states: any[];
	propertyProfilesList: any;
    titles !: any;
	isDisplayPropertyProfile : boolean = true;
	propertyProfileObj : PropertyProfile[] =[];
	ownerProfile: OwnerProfile;
    portalAccesses: any;
  msgTemplateData: MsgTemplateData;
	assignedToUserId;
	maintenanceSensitivities: any;
	incomeSensitivities: any;
	temperaments: any;
	engagementFreqOptions: any;
	ownerQualityOptions: any;
	slOwnerProfileId: any;
	checkShortTermRental: boolean;
	checkSlPropertyId: boolean;
	profileActive = false;
	havePortalAccess = false;
	haveOwnerProperty = false;
	onlyOneEmailAddress = false;
	propProfileHaveShortTermRental = false;
	shortTermRentalHaveSlPropertyId = false;
	visible = false;
	pictureUrl: any;
	checkOwnerHaveHomeOwnerPortalRole = false;
	user: any;
	satisfactionRanks: any[]=[];

	constructor(
		private constantService: ConstantService,
		private userService: UserService,
		private propertyService: PropertyService,
		private propertyProfileService: PropertyProfileService,
		private primengConfig: PrimeNGConfig,
		private ownerProfileService: OwnerProfileService,
		private alertService: AlertService,
		private activatedRoute: ActivatedRoute,
		private dialog: MatDialog,
		private primeNGConfig: PrimeNGConfig,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
			// data is null when the component is loaded via the Angular router (direct URL)
			// rather than opened as a MatDialog — guard all accesses
			this.formTitle = data?.title;
			this.isDisplayPropertyProfile = data?.isDisplayPropertyProfile == false ? false : true;
			this.ownerProfile = data?.ownerProfile;
			this.pictureUrl = data?.ownerProfile?.pictures?.[data?.ownerProfile?.pictures?.length - 1]?.url?.replace(/img/gi, "s3.us-east-1.amazonaws.com/img");
			this.slOwnerProfileId = data?.ownerProfile?.slOwnerProfileId;
			if(data?.ownerProfile?.anniversaryDate){
				this.ownerProfile.anniversaryDate = new Date(data.ownerProfile.anniversaryDate);
			}
			this.listingStatus = ownerProfileService.listingStatuses;
			this.contactPrefs = ownerProfileService.contactPrefs;
			this.portalAccesses = ownerProfileService.portalAccesses;
			this.countries = this.constantService.countries;
			this.states = this.constantService.states;
			this.titles = UserTitles;
			this.temperaments = ownerProfileService.temperaments;
			this.incomeSensitivities = ownerProfileService.incomeSensitivities;
			this.maintenanceSensitivities = ownerProfileService.maintenanceSensitivities;
			this.satisfactionRanks = ownerProfileService.satisfactionRanks;
			this.engagementFreqOptions = ownerProfileService.engagementFreqOptions;
			this.ownerQualityOptions = ownerProfileService.ownerQualityOptions;
	}

	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();
	@Output() doUpdateAccess = new EventEmitter<any>();

	// data
	ownerProfileId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	// data
	count: number;
	pictureProperties: any = {};
	pictureData: any;
    pictureIndex: number;

	// data
	uploadedFiles: any[] = [];
	pictureArray: any[] = [];
	pictures: any[] = [];

	numbers: any = [
		{ value: 0, name: '0' },
		{ value: 1, name: '1' },
    { value: 2, name: '2' },
    { value: 3, name: '3' },
    { value: 4, name: '4' },
    { value: 5, name: '5' },
    { value: 6, name: '6' },
    { value: 7, name: '7' },
    { value: 8, name: '8' },
    { value: 9, name: '9' },
    { value: 10, name: '10' },
    { value: 11, name: '11' },
    { value: 12, name: '12' },
    { value: 13, name: '13' },
    { value: 14, name: '14' },
    { value: 15, name: '15' },
    { value: 16, name: '16' },
    { value: 17, name: '17' },
    { value: 18, name: '18' },
    { value: 19, name: '19' },
    { value: 20, name: '20' },
    { value: 21, name: '21' },
	];

	notesChatConfig: NotesChatConfig = {
		title: 'Owner Profile Notes',
		maxWidth: '100%',
		maxHeight: '250px',
		customClass: '',
		fieldsPosition: 'top',
		showFilters: true,
		showSortOptions: false,
		fillParent: false,
		sortByDate: 'desc',
		allowEdit: true,
		allowDelete: false,
		allowAdd: true,
		emptyNotesText: 'No notes added',
		placeholder: 'Enter remarks',
		theme: 'default',
		maxNoteLength: 150,
		editButtonText: 'Edit Note',
		deleteButtonText: 'Delete Note',
		cancelButtonText: 'Cancel',
		noteTypes: [
			{ value: 1, name: 'General', color: '#DCDCDC' },
			{ value: 2, name: 'Action Item', color: '#ffcccc' },
			{ value: 4, name: 'Meeting Notes', color: '#ade061' },
			{ value: 5, name: 'Status Update', color: '#FFFF99' }
		],
		statusOptions: [
			{ value: 0, name: 'Open', color: '#D3D3D3' },
			{ value: 1, name: 'Complete', color: '#90EE90' },
			{ value: 2, name: 'Proposed', color: '#FFE599' },
			{ value: 3, name: 'On Hold', color: '#ADD8E6' },
			{ value: 4, name: 'Cancelled', color: '#F4A6A6' },
			{ value: 5, name: 'In Progress', color: '#FFA500' }
		]
	};

	guestValidationMessages =
    {
	  firstName: [{ type: 'required', message: 'Required' }],
      lastName: [{ type: 'required', message: 'Required' }],
	  emailAddress: [{ type: 'required', message: 'Required' }, { type: 'email', message: 'Please enter valid email' }],
	  mobile: [],
	  opsNotes: [],
	  relationship: [],
	}

	validationMessages =
    {
	  ownerProfileId: [],
	  slOwnerProfileId: [],
      title: [],
      firstName: [{ type: 'required', message: 'Required' }],
      middleName: [],
      lastName: [{ type: 'required', message: 'Required' }],
      suffix: [],
      emailAddress: [{ type: 'required', message: 'Required' }, { type: 'email', message: 'Please enter valid email' }],
	  emailAddress2: [],
      mobilePhone: [],
      listingStatus: [{ type: 'required', message: 'Required' }],
	  shortTermRentals:  [],
	  propertyCode: [],
	  anniversaryDate: [],
	  birthDate: [],
	  favSports: [],
	  education: [],
	  politics: [],
	  foodAndBevPrefs: [],
	  localVehicleDesc: [],
	  contactPref: [],
	  propertyProfileVOList:  [],
	  portalAccessBasic:  [],
	  companyName:[],
	mailAdrCompanyName: [],
	mailAdrStreet: [],
	mailAdrStreet2: [],
	mailAdrCity: [],
	mailAdrState: [],
	mailAdrPostalCode: [],
	mailAdrCountry: [],
	mailAdrPhone: [],
	mailAdrFax: [],
	contractSignDate: [],
	temperament: [],
	incomeSensitivity: [],
	maintenanceSensitivity: [],
	opsNotes: [],
	arrivalPrepDesc: [],
	spouseFirstName: [],
	spouseLastName: [],
	spouseEmailAdress: [],
	spouseMobile: [],
	spouseOpsNotes: [],
	aboutOwner: [],
	compHostNights: [],
	satisfactionRank:[],
	engagementFreq: [],
	ownerQuality: [],
    };

	ngOnInit() {
		this.primeNGConfig.ripple = true;
		//	fetch property profiles data
		this.fetchPropertyProfiles();
	//	this.fetchProperties();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole ownerProfile object
		if (this.ownerProfile) {
			this.ownerProfileLoad();
		} else {
			this.activatedRoute.params.subscribe(params => {
				this.ownerProfileId = params.ownerProfileId; // (+) converts string 'id' to a number
			});
			if (this.ownerProfileId != null && this.ownerProfileId != undefined) {
				this.findOwnerProfileById();
			}
		}
	}

	ownerProfileLoad(){
		this.ownerProfileId = this.ownerProfile.ownerProfileId;
			if(this.ownerProfile.portalAccessBasic != true){
				this.ownerProfile.portalAccessBasic = false;
			}
			if(this.ownerProfile.contractSignDate != undefined && this.ownerProfile.contractSignDate != null){
				this.ownerProfile.contractSignDate = moment(this.ownerProfile.contractSignDate).toDate();
			}
			if(this.ownerProfile.birthDate != undefined && this.ownerProfile.birthDate != null){
				this.ownerProfile.birthDate = moment(this.ownerProfile.birthDate).toDate();
			}
			if(this.ownerProfile.anniversaryDate != undefined && this.ownerProfile.anniversaryDate != null){
				this.ownerProfile.anniversaryDate = moment(this.ownerProfile.anniversaryDate).toDate();
			}
			this.fixDates();
			this.form1.patchValue(this.ownerProfile);
			if(this.ownerProfile.listingStatus === "active"){
				this.profileActive = true;
			}else{
				this.profileActive = false;
			}

			if(this.ownerProfile.portalAccessBasic === true){
				this.havePortalAccess = true;
			}else{
				this.havePortalAccess = false;
			}

			if(this.ownerProfile.propertyProfileVOList.length > 0){
				this.haveOwnerProperty = true;
			}else{
				this.haveOwnerProperty = false;
			}

			if(this.ownerProfile?.ownerUserId != null && this.ownerProfile?.ownerUserId != undefined){
				// this.checkOwnerHaveHomeOwnerPortalRoleOrNot(this.ownerProfile?.ownerUserId);
			}else{
				this.checkOwnerHaveHomeOwnerPortalRole = false;
			}
			this.checkPropertyProfileHaveShortTermRental();
			this.checkShortTermRentalHaveSlPropertyId()
			if(this.ownerProfile.emailAddress != null && this.ownerProfile.emailAddress != "" && this.ownerProfile.emailAddress != undefined){
				this.checkDuplicateEmailAddress(this.ownerProfile.emailAddress);
			}
      this.mergeDataWithTemplate();
      this.isDataLoaded = true;
	}

	// not used - resolver instead
	findById(id: number) {
		try {
			this.formLoading = true;
			this.propertyService.findById(id)
				.subscribe(
					res => {
						// console.log('property-find SUCCESS: ' + JSON.stringify(res));
						if(res.data.property.slPropertyId > 0){

						}else{
							this.checkSlPropertyId = true;
						}
					},
					err => {
						console.log('property-find FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	// not used - resolver instead
	checkDuplicateEmailAddress(emailAddress: any) {
		try {
			console.log("dodododo");
			this.formLoading = true;
			this.ownerProfileService.checkDuplicateEmailAddress(emailAddress)
				.subscribe(
					res => {
						// console.log('property-find SUCCESS: ' + JSON.stringify(res));
						if(res.data.ownerProfiles > 1){
								this.onlyOneEmailAddress = false;

						}else{
								this.onlyOneEmailAddress = true;

						}
					},
					err => {
						console.log('property-find FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	checkPropertyProfileHaveShortTermRental(){
		this.checkShortTermRental = false;
		if(this.ownerProfile.propertyProfileVOList.length > 0){
			this.ownerProfile.propertyProfileVOList.forEach(propertyProfile => {
				if(propertyProfile.shortTermRentalId > 0){
					this.findById(propertyProfile.shortTermRentalId);
				}else{
					this.checkShortTermRental = true;
				}

			});
			if(this.checkShortTermRental){
				this.propProfileHaveShortTermRental = false;
			}else{
				this.propProfileHaveShortTermRental = true
			}
			if(this.checkShortTermRental){
				this.shortTermRentalHaveSlPropertyId = false;
			}else{
				this.shortTermRentalHaveSlPropertyId = true;
			}

		}else{
			return false;
		}

	}

	checkShortTermRentalHaveSlPropertyId(){
		this.checkShortTermRental = false;
		if(this.ownerProfile.propertyProfileVOList.length > 0){
			this.ownerProfile.propertyProfileVOList.forEach(propertyProfile => {
				if(propertyProfile.shortTermRentalId > 0){
					this.findById(propertyProfile.shortTermRentalId);
				}else{
					this.checkSlPropertyId = true;
				}

			});
			if(this.checkSlPropertyId){
				return false
			}else{
				return true
			}

		}else{
			return false;
		}

	}

	checkOwnerHaveHomeOwnerPortalRoleOrNot(id: number){
		this.checkOwnerHaveHomeOwnerPortalRole = false;
		try {
			console.log("dodododo");
			this.formLoading = true;
			this.userService.findById(id)
				.subscribe(
					res => {
						// console.log('property-find SUCCESS: ' + JSON.stringify(res));
						this.user = res.data.user.userRoles;
						if (res.data.user.userRoles.length > 0) {
							res.data.user.userRoles.forEach(role => {
							  if (role.userRoleId == "1200") {
								this.checkOwnerHaveHomeOwnerPortalRole = true;
							  }
							});
						  }
						  if(this.checkOwnerHaveHomeOwnerPortalRole == true){
							if(this.ownerProfile.portalAccessBasic != true){
								this.form1.value.portalAccessBasic = true;
								this.updateOwnerPortalAccess();
							}
						  }
					},
					err => {
						console.log('property-find FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.ownerProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		console.log("Add Method called")
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.ownerProfileService.add(this.buildSafePayload())
				.subscribe(
					(res: any) => {
						this.formLoading = false;
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ownerProfile = res.data.ownerProfile;
						this.doAdd.emit(this.ownerProfile);
					},
					(err: any) => {
						// Do NOT reset formLoading on error — a 504 means the backend may
						// have already saved the owner profile. Keep button disabled to block re-submit.
						console.log('ownerProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.formLoading = false;
			this.alertService.error(error);
		}
	}

	setAssignedToUserId($event)
	{
		console.log($event);
		this.assignedToUserId = $event['assignedToUserId'];
	}

	/**
	 * Build a copy of the form value with date-only fields serialized as
	 * YYYY-MM-DD strings so Jackson can deserialize them into LocalDate on the
	 * backend.  PrimeNG calendar stores JavaScript Date objects which serialize
	 * as full ISO timestamps (e.g. "2024-03-15T10:00:00.000Z") — the time
	 * component and UTC offset cause Jackson LocalDate deserialization to fail.
	 */
	private buildSafePayload(): any {
		const v = { ...this.form1.value };
		const dateOnlyFields = ['anniversaryDate', 'birthDate', 'contractSignDate'];
		dateOnlyFields.forEach(field => {
			if (v[field]) {
				v[field] = moment(v[field]).format('YYYY-MM-DD');
			}
		});
		return v;
	}

	formUpdate() {
		console.log('ownerProfile: ' + JSON.stringify(this.form1.value));

		if (this.form1.value.emailAddress != null) {
			try {
				// stop here if form is invalid
				this.form1.markAllAsTouched();
				if (this.form1.invalid) {
					return;
				}
				this.formLoading = true;

				this.ownerProfileService.update(this.buildSafePayload())
					.subscribe(
						(res: any) => {
							this.formLoading = false;
							console.log('property-update SUCCESS: ' + JSON.stringify(res));
							this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
							this.ownerProfile = res.data.ownerProfile;
							this.doUpdate.emit(this.ownerProfile);
						},
						(err: any) => {
							// Do NOT reset formLoading on error — a 504 means the backend may
							// have already saved the update. Keep button disabled to block re-submit.
							console.log('property-update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { this.formLoading = false; });
			} catch (error) {
				this.formLoading = false;
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
	}

	formDelete() {
		try {
			this.ownerProfileService.delete(this.ownerProfile.ownerProfileId)
				.subscribe(
					(res: any) => {
						console.log('ownerProfile-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.ownerProfile);
					},
					(err: any) => {
						console.log('ownerProfile-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
	      ownerProfileId: [],
		  slOwnerProfileId: [this.slOwnerProfileId],
	      title: [],
	      firstName: ['', Validators.required],
	      middleName: [],
	      lastName: ['', Validators.required],
	      suffix: [],
	      emailAddress: ['', Validators.compose([
			Validators.required,
			Validators.email
		])],
		emailAddress2: [],
	      mobilePhone: [],
	      shortTermRentals:  [],
		  propertyCode: [],
	      listingStatus: ['onboarding', Validators.required],
	      accountManager: [],
		  anniversaryDate: [],
		  birthDate: [],
		  favSports: [],
		  education: [],
		  politics: [],
		  foodAndBevPrefs: [],
		  localVehicleDesc: [],
		  contactPref: ['email and mobile'],
          ownerProfileGuests: this.formBuilder.array([]),
		  propertyProfileVOList : [],
	  	  portalAccessBasic:  ['false'],
			companyName:[],
		mailAdrCompanyName: [],
		mailAdrStreet: [],
		mailAdrStreet2: [],
		mailAdrCity: [],
		mailAdrState: [],
		mailAdrPostalCode: [],
		mailAdrCountry: [],
		mailAdrPhone: [],
		mailAdrFax: [],
		contractSignDate: [],
		temperament: [],
		incomeSensitivity: [],
		maintenanceSensitivity: [],
		opsNotes: [],
		arrivalPrepDesc: [],
		spouseFirstName: [],
		spouseLastName: [],
		spouseEmailAdress: [],
		spouseMobile: [],
		spouseOpsNotes: [],
		aboutOwner: [],
		compHostNights: [],
		satisfactionRank:[],
		engagementFreq: [],
		ownerQuality: [],
	    });
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.ownerProfile.ownerProfileDate = moment(this.ownerProfile.ownerProfileDate).toDate();
	}

	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyProfileService.findAll()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.propertyProfiles;
							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}

	fetchPropertyProfiles(){
		try {
			this.propertyProfileService.findAll()
				.subscribe(
					res => {
						 console.log('findAllPropertyProfile: ' + JSON.stringify(res));
						this.propertyProfilesList = res.data.propertyProfiles;
						return this.propertyProfilesList;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formAddPropertyLead() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: "Add Property Profile",
			isDisplayOwnerProfile : false
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(
			PropertyProfileComponent,
			dialogConfig
		);

		dialogRef.componentInstance.doAdd.subscribe((data) => {
			console.log("Dialog output:", data);
			this.propertyProfilesList = [];
			this.fetchPropertyProfilesWhenAddOrUpdate(data);

			// close the dialogBox
			dialogRef.close();
		});
	}

	// update owner portal access
	updateOwnerPortalAccess() {
		console.log('ownerProfile: ' + JSON.stringify(this.form1.value));
			try {
				// stop here if form is invalid
				this.form1.markAllAsTouched();
				if (this.form1.invalid) {
					return;
				}
				this.formLoading = true;

				this.ownerProfileService.updateOwnerPortalAccess(this.form1.value)
					.subscribe(
						(res: any) => {
							this.formLoading = false;
							console.log('owner-update SUCCESS: ' + JSON.stringify(res));
							this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
							this.ownerProfile = res.data?.ownerProfile;
							this.doUpdateAccess.emit(this.ownerProfile);
							//this.doUpdate.emit(this.ownerProfile);
						},
						(err: any) => {
							// Do NOT reset formLoading on error — a 504 means the backend may
							// have already updated portal access. Keep button disabled to block re-submit.
							console.log('owner-update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { this.formLoading = false; });
			} catch (error) {
				this.formLoading = false;
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
	}

	fetchPropertyProfileById(propertyProfile: PropertyProfile){
		try {
			this.propertyProfileService.findById(propertyProfile?.propertyProfileId)
				.subscribe(
					res => {
						 console.log('ownerLeadProfileService: ' + JSON.stringify(res));
						this.onOpenFormEdit(res.data.propertyProfile);
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	onFormDeleteOfPropertyProfile(propertyProfile: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + propertyProfile?.propertyProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDeleteOfOwnerProfile(propertyProfile);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	deletePropertyAndOwnerProfile(propertyProfile: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete relationship between property and owner profile?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.deletePropertyAndOwnerProfileRelationship(propertyProfile);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	/*********
		* Edit Button
		*
		*/
		onOpenFormEdit(propertyProfile: PropertyProfile) {
			console.log("propertyProfile :"+JSON.stringify(propertyProfile));

			const dialogConfig = new MatDialogConfig();

			// settings
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;

			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				propertyProfile: propertyProfile,
				title: 'Edit Property Profile'
			};

			// open the popup and get a reference to it called dialogRef
			const dialogRef = this.dialog.open(PropertyProfileComponent, dialogConfig);

			// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
			dialogRef.componentInstance.doUpdate.subscribe(
				data => {
					console.log('Dialog output:', data);


					// close the dialogBox
					dialogRef.close();
				});

			dialogRef.componentInstance.doDelete.subscribe(
				data => {
					console.log('Dialog output:', data);


					// close the dialogBox
					dialogRef.close();
				});
			}

			formDeleteOfOwnerProfile(propertyProfile: any) {
				try {
					this.propertyProfileService.delete(propertyProfile?.propertyProfileId)
						.subscribe(
							(res: any) => {
								console.log('propertyProfile-delete SUCCESS: ' + JSON.stringify(res));
								this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
								this.fetchOwnerProfileById();
							},
							(err: any) => {
								console.log('propertyProfile-add FAIL: ' + JSON.stringify(err));
								this.alertService.error(err);
							},
							() => { this.formLoading = false; });
				} catch (error) {
					this.alertService.error(error);
				}
			}

			deletePropertyAndOwnerProfileRelationship(propertyProfile: any) {
				console.log("propertyProfile : ",JSON.stringify(propertyProfile));
				const propertyAndOwnerObj = {
					propertyProfileId: propertyProfile?.propertyProfileId,
					ownerProfileId: this.ownerProfile?.ownerProfileId,
				}
				try {
					this.propertyProfileService.deletePropertyAndOwnerProfileRelationship(propertyAndOwnerObj)
						.subscribe(
							(res: any) => {
								this.formLoading = false;
								console.log('propertyProfile-delete SUCCESS: ' + JSON.stringify(res));
								this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
								this.fetchOwnerProfileById();
							},
							(err: any) => {
								// Do NOT reset formLoading on error — keep button disabled to prevent
								// duplicate delete attempts after a 504 timeout.
								console.log('propertyProfile-add FAIL: ' + JSON.stringify(err));
								this.alertService.error(err);
							},
							() => { this.formLoading = false; });
				} catch (error) {
					this.formLoading = false;
					this.alertService.error(error);
				}
			}

			fetchOwnerProfileById(){
				try {
					this.ownerProfileService.findById(this.ownerProfile?.ownerProfileId)
						.subscribe(
							res => {
								this.formLoading = false;
								 console.log('ownerLeadProfileService: ' + JSON.stringify(res));
								 this.ownerProfile.propertyProfileVOList = res.data?.ownerProfile?.propertyProfileVOList;
								 this.form1.patchValue({
									propertyProfileVOList: ""
								 });
								 this.form1.patchValue({
									propertyProfileVOList: res.data?.ownerProfile?.propertyProfileVOList
								 });
							},
							err => {
								this.formLoading = false;
								console.log('Feature-Update FAIL: ' + JSON.stringify(err));
								this.alertService.error(err);
							},
							() => { });
				} catch (error) {
					this.formLoading = false;
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.alertService.error(error);
				}
		}

		updatePropertyProfileOfPropertyProfile() {
			try {
				this.formLoading = true;
				this.ownerProfile.propertyProfileVOList = this.form1.value.propertyProfileVOList;

				this.ownerProfileService.update(this.ownerProfile)
					.subscribe(
						(res: any) => {
							this.formLoading = false;
							console.log('property-update SUCCESS: ' + JSON.stringify(res));
							this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
							//this.propertyProfile = res.data.propertyProfile;
							//this.doUpdate.emit(this.propertyProfile);
						},
						(err: any) => {
							this.formLoading = false;
							console.log('property-update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { this.formLoading = false; });
			} catch (error) {
				this.formLoading = false;
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}

		fetchPropertyProfilesWhenAddOrUpdate(propertyProfile: any){
			try {
				this.propertyProfileService.findAll()
					.subscribe(
						res => {
							 console.log('findAllPropertyProfile: ' + JSON.stringify(res));
							this.propertyProfilesList = res.data.propertyProfiles;
							this.propertyProfilesList.forEach(event=> {
								if(event.propertyProfileId == propertyProfile.propertyProfileId){
									if (this.ownerProfile) {
										this.ownerProfile?.propertyProfileVOList.unshift(event);

										// no idea what this is but it is required to update the array
										this.ownerProfile.propertyProfileVOList = [...this.ownerProfile?.propertyProfileVOList];
										this.form1.patchValue({
											propertyProfileVOList: this.ownerProfile?.propertyProfileVOList
										});
									}
									else {
										console.log("DATA :: " + event);
										this.propertyProfileObj.push(event);
										console.log("propertyProfileObj :: " + JSON.stringify(this.propertyProfileObj));
										this.form1.patchValue({
											propertyProfileVOList: this.propertyProfileObj
										});
									}
								}
							 });

							//return this.propertyProfilesList;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}

		openDialogUploadImage(){
			this.visible = true;
		  }

		  myUploader(event: any) {
				this.pictureIndex = 0;
				this.uploadedFiles = event.files;
				this.uploadPicture();
			}

			uploadPicture() {
				this.formLoading = true;
				console.log('File name: ' + JSON.stringify(this.uploadedFiles[this.pictureIndex].name));
				try {
					this.ownerProfileService.uploadFileForOwnerProfile(this.uploadedFiles[this.pictureIndex], this.ownerProfileId)
						.subscribe(
							res => {
								this.pictureIndex = this.pictureIndex + 1;
								if (this.uploadedFiles.length != this.pictureIndex) {
									this.uploadPicture();
								} else {
									this.messageService.add({ severity: 'success', summary: 'Success', detail: "Upload Profile Picture Successfully" });
									this.formLoading = false;
					  this.visible = false;
								}
								console.log('Update picture successfully: ' + JSON.stringify(res));
							},
							err => {
								this.pictureIndex = this.pictureIndex + 1;
								if (this.uploadedFiles.length != this.pictureIndex) {
									this.uploadPicture();
								} else {
									// this.loadLazy(this.lazyLoadEvent);
									this.formLoading = false;
								}
								console.log('Update picture sort order FAIL: ' + JSON.stringify(err));
								this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
							},
							() => {});
				} catch (error) {
			  this.formLoading = false;
					console.log('Form Invalid: ' + JSON.stringify(error));
				}
			}

  mergeDataWithTemplate() {
    this.msgTemplateData = new MsgTemplateData();
    this.msgTemplateData.emailAddress = this.ownerProfile.emailAddress;
    this.msgTemplateData.fullName = this.ownerProfile.fullName;
    this.msgTemplateData.mobilePhone = this.ownerProfile.mobilePhone;
    this.msgTemplateData.firstName = this.ownerProfile.firstName;
  }

  findOwnerProfileById(){
      this.ownerProfileService.findById(this.ownerProfileId)
        .subscribe(
          (res: any) => {
            // Resolve the Promise with the picture file name
            this.ownerProfile = res?.data?.ownerProfile;
            this.ownerProfileLoad();
          },
          (err: any) => {
            console.log('quote-add FAIL: ' + JSON.stringify(err));
            // Reject the Promise if there's an error
          },
          () => {
            this.formLoading = false;
          }
        );
  }

  closePopUpOfQuote(){
	this.doUpdate.emit(null);
  }
}
